import type { SceneTagOption } from "../../api/preferenceService";

/**
 * 1006 — 客服「场景偏好」只列客服场景。
 *
 * api `scene-tag-options` 回的是 `xb_kb_scene_tag_dict` 里本行业 + 通用(industry_code NULL)的全部场景码,
 * 字典**没有「属于哪条线」的分类列**,只有 code/label/industry/sort_weight。V49 补进通用段的 12 个码里有 9 个是
 * 其它管线的标记(获客 / 内容选题 / 追爆 / 陪练 / 海报 / 视频 / 文案红线),不是客服检索场景,下拉里混着它们
 * 会让运营给客服挑到海报风格指南。
 *
 * 在 api 给出分类字段之前(建议:字典加 `scene_line` 列 cs/acq/content/coach/creative/guard,
 * `scene-tag-options` 接 `?line=cs` 过滤),console 按**已知非客服码**排除;
 * 前缀/后缀规则覆盖同族新码。排除后为空则保底回原列表,不让下拉只剩「全局」。
 */
const NON_CS_SCENE_CODES = new Set([
  "acq_signal",
  "acq_icp",
  "content_topic",
  "explosive_discover",
  "coach_roleplay",
  "poster_style",
  "video_style",
  "copy_guard",
  "content_guard",
]);
const NON_CS_PREFIXES = ["acq_", "content_", "explosive_", "coach_", "poster_", "video_"];
const NON_CS_SUFFIXES = ["_guard", "_style"];

export function isCustomerServiceScene(code: string): boolean {
  if (NON_CS_SCENE_CODES.has(code)) return false;
  if (NON_CS_PREFIXES.some((p) => code.startsWith(p))) return false;
  if (NON_CS_SUFFIXES.some((x) => code.endsWith(x))) return false;
  return true;
}

/**
 * 场景偏好下拉项。中文名优先级:租户自己改过的标签名 > 平台字典中文名 > 编码(兜底,正常不该出现)。
 * 1005:此前只拿编码,租户标签表里没有的就直出 cs_export_doc 之类内部码。
 * 1006:只留客服场景(见 {@link isCustomerServiceScene});全被滤掉时保底不滤。
 */
export function buildSceneOptions(
  options: SceneTagOption[] | undefined,
  tagDefs: { tagValue: string; name: string }[] | undefined
): { value: string; label: string }[] {
  const tenantLabel = new Map((tagDefs ?? []).map((def) => [def.tagValue, def.name]));
  const all = (options ?? []).filter((o) => o.code !== "");
  const cs = all.filter((o) => isCustomerServiceScene(o.code));
  return (cs.length > 0 ? cs : all).map((o) => ({
    value: o.code,
    label: tenantLabel.get(o.code) || o.label || o.code,
  }));
}
